export const PATH_INTRO_DATA = [
  {
    title: 'Opening Your Menu',
    image: 'assets/images/tour1.png',
    content: '<p>Your sidebar menu is collapsed by default. To <b>open</b> your menu, use the icon in the top-left of your screen.</p>'
  },
  {
    title: 'Navigation Menu',
    image: 'assets/images/tour2.png',
    content: '<p>Atlas organizes your course into <b>Sessions</b> and <b>Sections</b> (e.g., Quant, Verbal, etc.). Use this menu to navigate through the course. You can also view your progress here.</p>'
  },
  {
    title: 'Tasks',
    image: 'assets/images/tour3.png',
    content: '<p>Within a section, Atlas itemizes your study activities as <b>tasks</b>. They include readings, problem sets, on-demand lessons, etc.</p><p>Click on a task to view its details. Then, mark it complete with a checkmark. Or, skip a task and mark it "skipped". Atlas tracks your progress as you go.</p>'
  },
  {
    title: 'Additional Tasks',
    image: 'assets/images/tour4.png',
    content: '<p>If you\'re looking for more to do, scroll down to the bottom of a task list to add <b>extra practice tasks</b>.</p><p>They\'re labeled (e.g., "Easier," "Harder," etc.)  to help you decide what to add.</p>'
  },
  {
    title: 'Starred Tasks',
    image: 'assets/images/tour5.png',
    content: '<p>As you work, you have the option to <b>star</b> any task for review later. </p><p>Click the star menu to view and filter your starred tasks.</p>'
  },
  {
    title: 'Resource Menu',
    image: 'assets/images/tour6.png',
    content: '<p>Use this menu to get immediate access to every available resource, whenever you\'d like.</p><p>You\'ll generally follow the task list when you\'re using Atlas, but this menu is there for you when you want to go "off plan" and forge your own path.</p><p>No matter where you go within Atlas, you can always use the Home link to get back to your task list.</p>'
  },
  {
    title: 'Switch Syllabus',
    image: 'assets/images/tour7.png',
    content: '<p>The name of your current syllabus is displayed at the top of your screen. Use the arrow icon (&#x21c4;) to load any other syllabus you may have access to.</p>'
  }

]



// WEBPACK FOOTER //
// ./src/app/intro/path-intro.data.ts